/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StatementTransactionType {
    BONUS = 'Bonus',
    DEPOSIT = 'Deposit',
    WITHDRAWAL = 'Withdrawal',
    WITHDRAWAL_COMPLETE = 'WithdrawalComplete',
    WITHDRAWAL_DECLINE = 'WithdrawalDecline',
    WITHDRAWAL_REQUEST = 'WithdrawalRequest',
    WITHDRAWAL_REQUEST_COMPLETE = 'WithdrawalRequestComplete',
    WITHDRAWAL_REQUEST_DECLINE = 'WithdrawalRequestDecline',
    OTC_SPEND = 'OtcSpend',
    OTC_RECEIVE = 'OtcReceive',
    SPOT_TRADE_SPEND = 'SpotTradeSpend',
    SPOT_TRADE_RECEIVE = 'SpotTradeReceive',
    FEE = 'Fee',
    EARN_REWARD = 'EarnReward',
    EARN_TERMINATION_FEE = 'EarnTerminationFee',
    DERIVATIVES_PROFIT = 'DerivativesProfit',
    DERIVATIVES_LOSS = 'DerivativesLoss',
    DERIVATIVES_TRADING_FEE = 'DerivativesTradingFee',
    DERIVATIVES_FUNDING_FEE = 'DerivativesFundingFee',
    DERIVATIVES_FUNDING_FEE_REFUND = 'DerivativesFundingFeeRefund',
    DERIVATIVES_COMPENSATION = 'DerivativesCompensation',
    UNKNOWN = 'Unknown',
}
